<template>
  <div class="has-bg-white is-border is-clipped" style="overflow: visible !important;" :class="{'is-margin-bottom':hasMargin}">
    <div class="cis-border columns is-gapless row-width-actions-bar">
      <slot name="left-column-title">
        <div class="column">
          <div class="title is-3 has-text-weight-black" v-if="title">
            {{title}}
            <span v-show="loading" class="is-size-6"><i class="fal fa-spin fa-spinner is-margin-xsmall"></i></span>
          </div>
        </div>
      </slot>
      <slot name="column"></slot>
      <div class="column is-paddingless is-narrow has-text-right is-border-left" v-if="isAdmin && hasFilters">
        <a class="page-header-btn is-small" @click="displayPane = !displayPane" :class="displayPane ? 'has-text-primary' : 'has-text-draft'">
          <span class="icon">
            <i class="fas fa-filter"></i>
          </span>
          <span>Filtres Administrateur</span>
        </a>
      </div>
      <div class="column is-paddingless is-narrow has-text-right is-paddingless-left is-border-left dropdown is-hoverable is-right"
        v-if="hasSorts"
        v-on:mouseenter="displaySort = true" v-on:mouseleave="displaySort = false">
        <div class="dropdown-trigger" aria-haspopup="true" aria-controls="dropdown-menu">
          <a class="page-header-btn is-uppercase" :class="displaySort ? 'has-text-primary' : 'has-text-draft'">
            <span class="icon"><i class="fal fa-sort-amount-down"></i></span>
            <span>Trier</span>
          </a>
        </div>
        <div id="dropdown-menu" class="dropdown-menu" role="menu">
          <div class="dropdown-content has-text-left is-paddingless-top">
            <span class="dropdown-item column has-text-grey is-padding-small is-size-6" v-if="sortButtons.label">{{sortButtons.label}}</span>
            <a class="dropdown-item is-border-top" v-for="(btn, i) in sortButtons.buttons" :key="i"
               v-if="(!btn.needProfile || btn.needProfile.includes(currentUserProfil) || isSuperAdmin)"
               @click="sort(btn.key, btn.sort)"
               :class="currentSort === `${btn.key}:${btn.sort}` ? 'has-text-black' : ''">
              {{btn.label}}
            </a>
          </div>
        </div>
      </div>
      <div v-if="!isExternal" class="column is-paddingless is-narrow has-text-right is-paddingless-left is-border-left dropdown is-hoverable is-right">
        <slot name="multiselect"></slot>
      </div>
    </div>
    <div id="js-view-filtres" class="is-border-top is-border-dashed"
          v-if="isAdmin && displayPane">
      <slot name="filter"></slot>
    </div>
    <div class="columns is-gapless has-bg-light is-vcentered is-padding-right is-border-top is-padding-top-xsmall" v-if="hasTabLeft">
      <div class="column">
        <slot name="tab-left"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AdditionalFilter',
    data () {
      return {
        displaySort: false,
        displayPane: false
      }
    },
    props: {
      title: String,
      loading: {
        type: Boolean,
        default: false
      },
      hasMargin: {
        type: Boolean,
        default: true
      },
      sortLabel: String,
      sortButtons: {
        type: Object,
        default: () => {}
      },
      currentSort: {
        type: String
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'currentUserProfil', 'isSuperAdmin', 'isExternal']),
      hasFilters () {
        return this.$slots['filter'] && this.$slots['filter'].length
      },
      hasSorts () {
        return this.sortButtons && this.sortButtons.buttons && this.sortButtons.buttons.length
      },
      hasTabLeft () {
        return this.$slots['tab-left'] && this.$slots['tab-left'].length
      }
    },
    methods: {
      sort (key, sort) {
        this.$emit('sortStock', {key, sort})
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/utils/AdditionalFilter.vue